import { Component, Input } from '@angular/core';
import { getAvailabilityLevel } from 'src/app/shared/availability-level';

@Component({
    selector: 'app-availability-icon',
    standalone: true,
    templateUrl: './availability-icon.component.html',
    styleUrl: './availability-icon.component.scss',
})
export class AvailabilityIconComponent {
    @Input() total = 0;
    @Input() available = 0;
    @Input() icon = 'pi pi-chart-bar';

    get baseClass() {
        return `availability-icon__base ${this.icon}`;
    }

    get fillClass() {
        return `availability-icon__glyph ${this.icon}`;
    }

    get fillPercent() {
        switch (getAvailabilityLevel(this.available, this.total)) {
            case 'high':
                return '100%';
            case 'medium':
                return '50%';
            default:
                return '0%';
        }
    }

    get fillColor() {
        switch (getAvailabilityLevel(this.available, this.total)) {
            case 'high':
                return 'var(--blue-500)';
            case 'medium':
                return 'var(--orange-500)';
            default:
                return 'var(--text-color-secondary)';
        }
    }
}
